"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRAFFIC_TYPE_TOUCH = exports.TRAFFIC_TYPE_HOVER = exports.TRAFFIC_TYPE_CUSTOM = exports.TRAFFIC_TYPE_CLICK = exports.TRAFFIC_EID_TOPIC_VIEW = exports.TRAFFIC_EID_TOPIC_CLICK = exports.TRAFFIC_EID_TOPIC_CATEGORY_CLICK = exports.TRAFFIC_EID_SEARCH_SUGGESTIONS_VIEW = exports.TRAFFIC_EID_SEARCH_SUGGESTION_CLICK = exports.TRAFFIC_EID_SEARCH_SUBMIT = exports.TRAFFIC_EID_SEARCH_RESULTS_VIEW = exports.TRAFFIC_EID_SEARCH_RESULT_CLICK = exports.TRAFFIC_EID_NAVIGATION_CLICK = exports.TRAFFIC_EID_BREADCRUMB_CLICK = exports.TRAFFIC_EID_FOOTER_CLICK = exports.TRAFFIC_EID_ARTICLE_VIEW = exports.TRAFFIC_EID_ARTICLE_CLICK = exports.SEARCH_RESULTS_COUNT = exports.MARKET_EN_US = exports.LOCALSTORAGE_KEY_STORE_EXPIRES = exports.LOCALSTORAGE_KEY_STORE = exports.HOST_PATH = exports.CLASS_APP_CONTAINER = exports.API_HOST = exports.ENV_STRINGS = void 0;

/* eslint-disable id-length */
var ENV_STRINGS = {
  dev: 'dev',
  prod: 'prod',
  test: 'test'
};
exports.ENV_STRINGS = ENV_STRINGS;
var API_HOST = 'origin-help';
exports.API_HOST = API_HOST;
var CLASS_APP_CONTAINER = 'help--app-container';
exports.CLASS_APP_CONTAINER = CLASS_APP_CONTAINER;
var HOST_PATH = 'https://www.godaddy.com/help';
exports.HOST_PATH = HOST_PATH;
var LOCALSTORAGE_KEY_STORE = 'help-browse-store';
exports.LOCALSTORAGE_KEY_STORE = LOCALSTORAGE_KEY_STORE;
var LOCALSTORAGE_KEY_STORE_EXPIRES = 'help-browse-store-expires';
exports.LOCALSTORAGE_KEY_STORE_EXPIRES = LOCALSTORAGE_KEY_STORE_EXPIRES;
var MARKET_EN_US = 'en-US';
exports.MARKET_EN_US = MARKET_EN_US;
var SEARCH_RESULTS_COUNT = 10;
exports.SEARCH_RESULTS_COUNT = SEARCH_RESULTS_COUNT;
var TRAFFIC_EID_ARTICLE_CLICK = 'dc.sidekick.browse.article.click';
exports.TRAFFIC_EID_ARTICLE_CLICK = TRAFFIC_EID_ARTICLE_CLICK;
var TRAFFIC_EID_ARTICLE_VIEW = 'dc.sidekick.browse.article.view';
exports.TRAFFIC_EID_ARTICLE_VIEW = TRAFFIC_EID_ARTICLE_VIEW;
var TRAFFIC_EID_FOOTER_CLICK = 'dc.sidekick.browse.footer.click';
exports.TRAFFIC_EID_FOOTER_CLICK = TRAFFIC_EID_FOOTER_CLICK;
var TRAFFIC_EID_BREADCRUMB_CLICK = 'dc.sidekick.browse.breadcrumb.click';
exports.TRAFFIC_EID_BREADCRUMB_CLICK = TRAFFIC_EID_BREADCRUMB_CLICK;
var TRAFFIC_EID_NAVIGATION_CLICK = 'dc.sidekick.browse.navigation.click';
exports.TRAFFIC_EID_NAVIGATION_CLICK = TRAFFIC_EID_NAVIGATION_CLICK;
var TRAFFIC_EID_SEARCH_RESULT_CLICK = 'dc.sidekick.browse.search-result.click';
exports.TRAFFIC_EID_SEARCH_RESULT_CLICK = TRAFFIC_EID_SEARCH_RESULT_CLICK;
var TRAFFIC_EID_SEARCH_RESULTS_VIEW = 'dc.sidekick.browse.search-results.view';
exports.TRAFFIC_EID_SEARCH_RESULTS_VIEW = TRAFFIC_EID_SEARCH_RESULTS_VIEW;
var TRAFFIC_EID_SEARCH_SUBMIT = 'dc.sidekick.browse.search.submit';
exports.TRAFFIC_EID_SEARCH_SUBMIT = TRAFFIC_EID_SEARCH_SUBMIT;
var TRAFFIC_EID_SEARCH_SUGGESTION_CLICK = 'dc.sidekick.browse.search-suggestion.click';
exports.TRAFFIC_EID_SEARCH_SUGGESTION_CLICK = TRAFFIC_EID_SEARCH_SUGGESTION_CLICK;
var TRAFFIC_EID_SEARCH_SUGGESTIONS_VIEW = 'dc.sidekick.browse.search-suggestions.view';
exports.TRAFFIC_EID_SEARCH_SUGGESTIONS_VIEW = TRAFFIC_EID_SEARCH_SUGGESTIONS_VIEW;
var TRAFFIC_EID_TOPIC_CATEGORY_CLICK = 'dc.sidekick.browse.topic-category.click';
exports.TRAFFIC_EID_TOPIC_CATEGORY_CLICK = TRAFFIC_EID_TOPIC_CATEGORY_CLICK;
var TRAFFIC_EID_TOPIC_CLICK = 'dc.sidekick.browse.topic.click';
exports.TRAFFIC_EID_TOPIC_CLICK = TRAFFIC_EID_TOPIC_CLICK;
var TRAFFIC_EID_TOPIC_VIEW = 'dc.sidekick.browse.topic.view';
exports.TRAFFIC_EID_TOPIC_VIEW = TRAFFIC_EID_TOPIC_VIEW;
var TRAFFIC_TYPE_CLICK = 'click';
exports.TRAFFIC_TYPE_CLICK = TRAFFIC_TYPE_CLICK;
var TRAFFIC_TYPE_CUSTOM = 'custom';
exports.TRAFFIC_TYPE_CUSTOM = TRAFFIC_TYPE_CUSTOM;
var TRAFFIC_TYPE_HOVER = 'hover';
exports.TRAFFIC_TYPE_HOVER = TRAFFIC_TYPE_HOVER;
var TRAFFIC_TYPE_TOUCH = 'touch';
exports.TRAFFIC_TYPE_TOUCH = TRAFFIC_TYPE_TOUCH;